import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Logo } from "../components/Logo";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative min-h-screen bg-[#071510] grid place-items-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="relative w-full max-w-md rounded-[28px] bg-[#FAF8F5] p-8 sm:p-10" data-testid="admin-login-form">
        <Logo />
        <p className="mt-10 font-mono-d text-[11px] uppercase tracking-[0.22em] text-[#A8701F] flex items-center gap-2"><Lock className="w-3.5 h-3.5" /> Private</p>
        <h1 className="font-serif-d text-4xl text-[#0B281E] mt-2">Lead Inbox</h1>
        <div className="mt-8 flex flex-col gap-4">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="h-12 rounded-xl bg-white" data-testid="admin-login-email" />
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="h-12 rounded-xl bg-white" data-testid="admin-login-password" />
        </div>
        {error && <p className="mt-4 text-sm text-[#B91C1C]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full inline-flex justify-center items-center gap-2 rounded-full bg-[#0B281E] text-[#FAF8F5] py-4 font-semibold hover:bg-[#C88A35] hover:text-[#071510] transition-colors disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
        </button>
        <a href="/" className="mt-6 block text-center text-sm text-[#52635B] hover:text-[#0B281E]" data-testid="admin-back-to-site">← Back to website</a>
      </form>
    </div>
  );
}
